import * as React from 'react';
import { useIntl } from 'react-intl';
import { CmdLoader } from '@commander-services/gui-components';
import dayjs from 'dayjs';
import { useRecoilValue } from 'recoil';
import { IDetailWaypointResponseData } from './types';
import WaypointIconService from './WaypointIconService';
import { waypointDataAtom, waypointIdAtom } from './WaypointState';

interface IWaypointDetailForm {
  closeDetail: (event?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  id: number | null;
}

function WaypointDetailForm(props: IWaypointDetailForm): JSX.Element {
  const { formatMessage: f } = useIntl();
  const waypointData = useRecoilValue<IDetailWaypointResponseData | null>(waypointDataAtom);
  const waypointId = useRecoilValue<number | null>(waypointIdAtom);

  React.useEffect(() => {
    if (waypointId !== props.id) {
      props.closeDetail();
    }
  }, [props, waypointId]);

  return (
    <div className="b-mc-waypoints">
      {!waypointData && <CmdLoader inContent={true} />}
      <div className="b-mc-waypoints-title">
        <a href="#">
          <i className="cmd-icon cmd-icon-back mr-1" onClick={props.closeDetail} />
          {f({ id: 'waypoints.detail.title' })}
        </a>
      </div>
      <div className="b-waypoints-detail">
        <div className="item">
          <div className="row">
            <div className="col font-weight-bold">{f({ id: 'waypoints.form.customer.title' })}</div>
            <div className="col-auto text-right">
              {waypointData && waypointData.customerName && waypointData.customerLabel
                ? `${waypointData.customerName} (${waypointData.customerLabel})`
                : ''}
            </div>
          </div>
        </div>
        <div className="item">
          <div className="row">
            <div className="col font-weight-bold">{f({ id: 'waypoints.form.category.title' })}</div>
            <div className="col-auto text-right">
              <i
                className={`cmd-icon cmd-icon-${WaypointIconService.getCssIcon(
                  waypointData && waypointData.category ? waypointData.category.icon : 'default'
                )}

                } mr-1`}
              />
              {waypointData && waypointData.category
                ? waypointData.category.name
                : f({ id: 'waypoints.form.customer.title' })}
            </div>
          </div>
        </div>
        <div className="item">
          <div className="row">
            <div className="col font-weight-bold">{f({ id: 'waypoints.detail.item.title' })}</div>
            <div className="col-auto text-right">{waypointData && waypointData.name}</div>
          </div>
        </div>
        <div className="item">
          <div className="row">
            <div className="col font-weight-bold">{f({ id: 'waypoints.detail.item.type' })}</div>
            <div className="col-auto text-right">
              {waypointData && waypointData.type === 'private'
                ? f({ id: 'waypoints.detail.item.private' })
                : f({ id: 'waypoints.detail.item.customer' })}
            </div>
          </div>
        </div>

        <div className="item">
          <div className="row">
            <div className="col font-weight-bold">{f({ id: 'table_list.columns.createdBy' })}</div>
            <div className="col-auto text-right">
              {waypointData && waypointData.createdByName ? `${waypointData.createdByName}` : ''}
              <br />
              {waypointData && waypointData.createdAt
                ? `${dayjs(waypointData.createdAt).format('DD.MM.YYYY')}, ${dayjs(
                    waypointData.createdAt
                  ).format('HH:mm')} `
                : ''}
            </div>
          </div>
        </div>
        <div className="item">
          <div className="row">
            <div className="col font-weight-bold">
              {f({ id: 'waypoints.form.detail.modified' })}
            </div>
            <div className="col-auto text-right">
              {waypointData && waypointData.modifiedByName ? `${waypointData.modifiedByName}` : ''}
              <br />
              {waypointData && waypointData.modifiedAt
                ? `${dayjs(waypointData.modifiedAt).format('DD.MM.YYYY')}, ${dayjs(
                    waypointData.modifiedAt
                  ).format('HH:mm')} `
                : ''}
            </div>
          </div>
        </div>
      </div>
      <div className="b-mc-waypoints-footer">
        <div className="row">
          <div className="col">
            <a href="#" className="e-button e-button--gray" onClick={props.closeDetail}>
              {f({ id: 'waypoints.detail.cancel' })}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WaypointDetailForm;
